import { Component, Input, OnInit } from '@angular/core';
import { DrawerBaseComponent } from '@app/shared/bases';
import { SideBarDataSharingService } from '@app/shared/services/side-bar';

@Component({
    selector: 'app-expense-add-drawer',
    templateUrl: './expense-add-drawer.component.html',
    styleUrls: ['./expense-add-drawer.component.scss'],
    standalone: false
})
export class ExpenseAddDrawerComponent
  extends DrawerBaseComponent
  implements OnInit
{
  /**
   * Defines uid of the invoice for which the expense needs to be created
   */
  @Input() invoiceUid: string;

  constructor(protected sideBarDataSharingService: SideBarDataSharingService) {
    super(sideBarDataSharingService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * send expenseUid on close Side drawer
   * @param expenseUid
   */
  closeSideDrawer(expenseUid: string) {
    this.sideBarDataSharingService.closeComponent(expenseUid);
  }
}
